if (!window.rebCartStrapsBound) {
  window.rebCartStrapsBound = true;
  window.rebUpdateCartShipping = () => {
    document.querySelectorAll('.reb-cart-reassurance[data-reb-shipping-threshold]').forEach((reassurance) => {
      if (reassurance.dataset.rebCartCurrency === reassurance.dataset.rebShopCurrency) return;
      const rate = Number(window.Shopify?.currency?.rate);
      const threshold = Number(reassurance.dataset.rebShippingThreshold);
      const total = Number(reassurance.dataset.rebCartTotal);
      if (!Number.isFinite(rate) || rate <= 0 || !Number.isFinite(threshold) || !Number.isFinite(total)) return;

      const convertedThreshold = Math.round(threshold * rate);
      if (convertedThreshold <= 0) return;
      const remaining = convertedThreshold - total;
      const message = reassurance.querySelector('.reb-cart-shipping-message');
      const progress = reassurance.querySelector('.reb-cart-progress');
      if (remaining <= 0) {
        message.textContent = reassurance.dataset.rebShippingMet;
        progress.hidden = true;
        return;
      }

      const amount = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: reassurance.dataset.rebCartCurrency
      }).format(remaining / 100);
      message.textContent = `${reassurance.dataset.rebShippingBefore} ${amount} ${reassurance.dataset.rebShippingAfter}`;
      const percent = Math.max(0, Math.min(100, Math.floor(total * 100 / convertedThreshold)));
      progress.hidden = false;
      progress.setAttribute('aria-valuenow', percent);
      progress.querySelector('span').style.width = `${percent}%`;
    });
  };
  window.rebUpdateCartShipping();
  window.addEventListener('load', window.rebUpdateCartShipping);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-reb-cart-straps-add]');
    if (!button) return;
    event.preventDefault();
    const error = button.parentElement.querySelector('.reb-cart-straps__error');
    button.disabled = true;
    error.hidden = true;
    let added = false;
    try {
      const drawer = document.querySelector('cart-drawer');
      const cartItems = document.querySelector('cart-items');
      const cartSections = cartItems?.getSectionsToRender?.();
      const data = new FormData();
      data.append('id', button.dataset.variantId);
      data.append('quantity', '1');
      if (cartSections) {
        data.append('sections', cartSections.map((section) => section.section).join(','));
        data.append('sections_url', window.location.pathname);
      } else if (drawer && typeof drawer.renderContents === 'function') {
        data.append('sections', 'cart-drawer,cart-icon-bubble');
        data.append('sections_url', window.location.pathname);
      }
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || button.dataset.error);
      added = true;
      if (cartSections) {
        const getReplacements = (sections) => cartSections.map((section) => {
          const container = document.getElementById(section.id);
          const target = container?.querySelector(section.selector) || container;
          const html = sections?.[section.section];
          const contents = html && cartItems.getSectionInnerHTML(html, section.selector);
          return target && contents ? { target, html: contents } : null;
        });
        let replacements = getReplacements(result.sections);
        if (replacements.includes(null)) {
          console.warn('Missing cart section after adding extension straps; fetching cart sections.');
          const sectionsUrl = new URL(window.routes?.cart_url || '/cart', window.location.origin);
          sectionsUrl.searchParams.set('sections', cartSections.map((section) => section.section).join(','));
          const sectionsResponse = await fetch(sectionsUrl);
          if (!sectionsResponse.ok) throw new Error('Could not refresh cart sections');
          replacements = getReplacements(await sectionsResponse.json());
          if (replacements.includes(null)) throw new Error('Cart sections are still missing');
        }
        replacements.forEach(({ target, html }) => { target.innerHTML = html; });
        cartItems.classList.remove('is-empty');
        document.getElementById('main-cart-footer')?.classList.remove('is-empty');
        window.rebUpdateCartShipping?.();
        if (window.Shopify?.PaymentButton?.init) Shopify.PaymentButton.init();
        const card = document.querySelector('.reb-cart-page-footer__card');
        if (card) {
          card.tabIndex = -1;
          card.focus();
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'reb-cart-straps', cartData: result, variantId: button.dataset.variantId });
      } else if (drawer && typeof drawer.renderContents === 'function') {
        if (!result.sections?.['cart-drawer']) {
          console.warn('Missing cart drawer section after adding extension straps; fetching cart sections.');
          const sectionsUrl = new URL(window.routes?.cart_url || '/cart', window.location.origin);
          sectionsUrl.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
          const sectionsResponse = await fetch(sectionsUrl);
          if (!sectionsResponse.ok) throw new Error('Could not refresh cart drawer');
          result.sections = await sectionsResponse.json();
          if (!result.sections?.['cart-drawer']) throw new Error('Cart drawer section is still missing');
        }
        drawer.renderContents(result);
      } else {
        throw new Error('Missing cart drawer section');
      }
    } catch (failure) {
      console.error('Could not add extension straps:', failure);
      if (added) {
        window.location.reload();
        return;
      }
      error.textContent = button.dataset.error;
      error.hidden = false;
      button.disabled = false;
    }
  });
}
